<template>
  <div class="wrapper">
    <h6 class="card-title">Steps to authorise your account:</h6>
    <ul>
      <li>
        Go to
        <a href="https://printify.com/app/register" target="_black">Link</a>
        and initialize the app with all permissions.
      </li>
      <li>After submitting the form, a token will be returned. Paste the token below and save it.</li>
    </ul>
    <div class="printify_popup_wrap">
      <div class="printify_popup_container row">
        <div class="position-relative form-group col-12">
          <label class="col-12 mb-0 p-0">Shop Name*</label>
          <input class="form-control mt-2" type="text" :value="data.name" @change.stop.prevent="store.commit('name', $event.target.value)" />
        </div>
        <div class="position-relative form-group col-12">
          <label>Access Token</label>
          <textarea class="form-control" @change.stop.prevent="store.commit('integration.api.token', $event.target.value)"></textarea>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Event from '@/helper/event.js'

export default {
  mixins: [Event],
  computed: {
    action() {
      return this.config?.action
    },
    storeId() {
      return this.config?.storeId
    },
    accountId() {
      return this.config?.accountId
    },
    submitUri() {
      return `supplier-account/update/${this.accountId}`
    },
    data() {
      return this.store.getter('', {})
    },
    integration() {
      return _.mergeLeft(
        {
          api: {
            token: ''
          }
        },
        this.data.integration || {}
      )
    }
  },
  mounted() {
    this.$emitter.on('Modal.SupplierAccount.Edit.Submit', this.submit)
  },
  unmounted() {
    this.$emitter.off('Modal.SupplierAccount.Edit.Submit', this.submit)
  },
  methods: {
    submit(data) {
      this.submitForm(data, {
        done: () => {
          this.$emitter.emit('TableList.Refresh')
          this.$emit('close')
        }
      })
    }
  },
  props: {
    config: Object
  }
}
</script>
